import type { MessageResponseFragmentFragment } from '@codezo/graphql';

/**
 * Extracts the first error message from a MessageResponse.
 * GraphQL mutations return 200 with { success, message, errors } —
 * this helper checks the success field and returns the error message if failed.
 *
 * @example
 * const error = getMutationError(data.createUser);
 * if (error) {
 *   toast.error('Failed to create user', { description: error });
 *   return;
 * }
 * toast.success('User created');
 */
export function getMutationError(
	response: MessageResponseFragmentFragment | null | undefined
): string | null {
	if (!response || response.success) return null;
	return response.errors?.[0]?.message || response.message || 'An unexpected error occurred';
}
